import { motion, useScroll, useTransform } from "framer-motion";
import { ReactNode, useRef } from "react";

interface ScrollAnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export const ScrollAnimatedSection = ({ 
  children, 
  className = "", 
  delay = 0 
}: ScrollAnimatedSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  
  // Track scroll progress of this element
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  // Transform scroll progress to opacity (0 → 1)
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0, 1, 1, 0.8]);
  
  // Transform scroll progress to y-position (50px → 0)
  const y = useTransform(scrollYProgress, [0, 0.3], [50, 0]);
  
  return (
    <motion.div
      ref={ref}
      style={{ opacity, y }}
      transition={{ delay, duration: 0.6, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
